<template>
  <nav class="w-full bg-white sticky top-0 z-[40] h-16 shadow-sm">
    <div class="flex justify-between mx-auto w-full max-w-full h-full">
      <div class="w-[45%] px-6 flex justify-start py-3 text-text text-xl h-full items-center">
        <p class="pl-10">{{ authStore.user.companyName }}</p>
      </div>

      <div class="hidden lg:flex items-center w-[55%] justify-end">
        <div class="flex items-center justify-end space-x-10 mr-6 w-fit ml-10">
          <template v-if="authStore.user && authStore.user.au">
            <div class="flex items-center space-x-3">
              <p class="text-md font-medium whitespace-nowrap">Admin: {{
                  authStore.user.au.getFullName()
                }}</p>
              <button
                  @click="logoutAdmin()"
                  class="text-primary border border-primary px-6 py-1.5 rounded-full hover:bg-accent hover:border-accent hover:text-white transition-all"
              >
                Log out
              </button>
            </div>
          </template>
          <div class="flex justify-between items-center space-x-3">
            <NavbarCalendar></NavbarCalendar>
            <NavbarNotifications></NavbarNotifications>
          </div>
          <div class="items-center flex space-x-3">
            <p class="text-md font-medium text-text">Hello {{ authStore.user?.first_name }},</p>
            <div id="dropdown" @click="clickedmenu = !clickedmenu" class="flex space-x-3 relative cursor-pointer">
              <div v-if="authStore.user.image_data === null">
                <div class="rounded-full bg-primary w-11 h-11 flex items-center justify-center pointer-events-none">
                  <span class="contents text-white text-center block text-base font-semibold">{{
                      authStore.user?.getInitials()
                    }}</span>
                </div>
              </div>
              <div v-else>
                <img class="max-w-11 max-h-11 rounded-full object-cover" :src="authStore.user?.getProfilePicture()"
                     alt="Profile"/>
              </div>
              <img
                  :class="clickedmenu === true ? ' rotate-0 transition duration-150 ease-out' : 'rotate-180 transition duration-150 ease-out'"
                  src="@/assets/img/arrow.svg" class="pointer-events-none" alt="arrow"/>
              <Transition name="slide-fade">
                <div v-if="clickedmenu"
                     class="absolute bg-white z-10 top-16 text-text min-w-[280px] shadow-md py-4 px-6 rounded-md flex-col flex justify-start right-0 space-y-3">
                  <div class="flex space-x-3 items-center ">
                    <div v-if="authStore.user.image_data === null">
                      <div
                          class="rounded-full bg-primary w-11 h-11 flex items-center justify-center pointer-events-none">
                        <span class="contents text-white text-center block text-base font-semibold">
                          {{ authStore.user?.getInitials() }}
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <img class="max-w-11 max-h-11 rounded-full object-cover"
                           :src="authStore.user?.getProfilePicture()" alt="Profile">
                    </div>
                    <p>{{ authStore.user?.first_name }} {{ authStore.user?.last_name }}</p>
                  </div>
                  <RouterLink class="hover:text-secondary" to="/">Home</RouterLink>
                  <RouterLink
                      v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_MYPROFILE_ENABLED])"
                      class="hover:text-secondary"
                      :to="{ name:'my-profile', params: { id: authStore.user?.id } }">
                    {{ $t("nav.my-profile") }}
                  </RouterLink>
                  <RouterLink
                      v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_COMPANYPROFILE_ENABLED])"
                      class="hover:text-secondary"
                      :to="{ name:'company-profile', params: { id: authStore.user?.id } }">
                    {{ $t("nav.company-profile") }}
                  </RouterLink>
                  <div class="border-t border-b-gray-300 pt-3">
                    <a class="cursor-pointer hover:text-secondary" @click="logout()">Logout</a>
                  </div>
                </div>
              </Transition>
            </div>
            <button @click="openWidget()" type="button"
                    class="text-white bg-orange-400 border border-orange-500 px-6 py-1.5 rounded-full hover:bg-orange-600 hover:border-orange-600 hover:text-white transition-all"
            > Help
              <svg class="w-5 h-5 cursor-pointer inline-flex" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                   fill="currentColor">
                <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                      clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
        class="w-full h-20 lg:h-10 bg-white border-t border-gray-200 grid lg:grid-cols-2 grid-cols-1  px-5 items-center">
      <p class="font-medium text-lg text-dark2 flex h-full">
        <span v-if="route.name === 'home'" class="min-w-[200px] inline-flex items-center">Dashboard</span>
        <span v-if="route.name === 'documentation'" class="min-w-[200px] inline-flex items-center">User Manual</span>
        <span v-if="route.name === 'users'" class="min-w-[200px] inline-flex items-center">Users</span>
        <span v-if="route.name === 'manage-user'" class="min-w-[200px] inline-flex items-center">Manage User</span>
        <span v-if="route.name === 'activity-log'"
              class="min-w-[200px] inline-flex items-center">Activity Log</span>
        <span v-if="route.name === 'roles-permissions'" class="min-w-[200px] inline-flex items-center">Roles & Permissions</span>
        <span v-if="route.name === 'air'" class="min-w-[200px] inline-flex items-center">Air </span>
        <span v-if="route.name === 'ocean'" class="min-w-[200px] inline-flex items-center">Ocean </span>
        <span v-if="route.name === 'domestic-shipments'"
              class="min-w-[200px] inline-flex items-center">Domestic Road</span>
        <span v-if="route.name === 'international-shipments'" class="min-w-[200px] inline-flex items-center">International Road</span>
        <span v-if="route.name === 'inbounds'" class="min-w-[200px] inline-flex items-center"> Warehousing Simplify Reception / Return</span>
        <span v-if="route.name === 'outbounds'"
              class="min-w-[200px] inline-flex items-center">Warehousing Simplify Orders</span>
        <span v-if="route.name === 'vbs-inbounds'" class="min-w-[200px] inline-flex items-center">Warehousing Reception / Return</span>
        <span v-if="route.name === 'vbs-outbounds'"
              class="min-w-[200px] inline-flex items-center">Warehousing Orders</span>
        <span v-if="route.name === 'customers'" class="min-w-[200px] inline-flex items-center">Issued by KLG</span>
        <span v-if="route.name === 'order-entry-international-road-transport'"
              class="min-w-[200px] inline-flex items-center">Order Entry - International Road Transport</span>
        <span v-if="route.name === 'order-entry-domestic-road-transport'"
              class="min-w-[200px] inline-flex items-center">Order Entry - Domestic Road Transport</span>
        <span v-if="route.name === 'order-entry-strongo-transport'"
              class="min-w-[200px] inline-flex items-center">Order Entry - Strongo Transport</span>
        <span v-if="route.name === 'customer-invoice-details'" class="min-w-[200px] inline-flex items-center">Invoice Details</span>
        <span v-if="route.name === 'strongo-shipments'" class="min-w-[200px] inline-flex items-center">Strongo</span>
        <span v-if="route.name === 'shipment-overview'|| route.name === 'strongo-shipment-overview'"
              class="min-w-[200px] inline-flex items-center">Shipment Overview</span>
                <span v-if="route.name === 'claims'" class="min-w-[200px] inline-flex items-center">Claims</span>
                <span v-if="route.name === 'claim-information'"
                      class="min-w-[200px] inline-flex items-center">Claim Overview</span>
        <span v-if="route.name === 'news'"
              class="min-w-[200px] inline-flex items-center">Releases</span>
        <span v-if="route.name === 'self-service-news'"
              class="min-w-[200px] inline-flex items-center">API Releases</span>
        <span v-if="route.name === 'company-profile'"
              class="min-w-[200px] inline-flex items-center">Company Profile</span>
        <span v-if="route.name === 'my-profile'"
              class="min-w-[200px] inline-flex items-center">My Profile</span>
        <span v-if="route.name === 'docs'"
              class="flex items-center justify-end space-x-5">
          <span>API Docs</span>
        </span>
      </p>
      <template v-if="ONECLICK_ENV === 'ana'">
        <div v-if="route.name === 'docs'"
             class="flex items-center justify-end space-x-5">
          <div class="postman-run-button"
               data-postman-action="collection/fork"
               data-postman-visibility="public"
               data-postman-var-1="26567055-ce6f79f9-78c1-406d-a049-1845d45904c9"
               data-postman-collection-url="entityId=26567055-ce6f79f9-78c1-406d-a049-1845d45904c9&entityType=collection&workspaceId=a40a8123-dc76-40cc-8d67-db4f4ba10b28"></div>
          <Script src="/postman-button-init.js"></Script>
        </div>
      </template>

      <template v-else-if="ONECLICK_ENV === 'production'">
        <div v-if="route.name === 'docs'" class="flex items-center justify-end space-x-5">
          <div class="postman-run-button"
               data-postman-action="collection/fork"
               data-postman-visibility="public"
               data-postman-var-1="46086881-67f494db-2485-416d-985e-38e9bd207812"
               data-postman-collection-url="entityId=46086881-67f494db-2485-416d-985e-38e9bd207812&entityType=collection&workspaceId=38d53adc-05f4-4365-8087-7771b28085a8"></div>
          <Script src="/postman-button-init.js"></Script>
        </div>
      </template>

      <div class="flex items-center justify-end space-x-5">
        <template v-if="shouldShowDateFilter">
          <p v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_DASHBOARD_ENABLED])"
             class="text-text text-[12px] mt-0.5">Period</p>
          <div class="w-[230px] custom-border-container">
            <Multiselect
                v-if="authStore.accountPermissions.allowedAny([KPN.MANAGE_DASHBOARD_ENABLED])"
                class="h-[30px] custom-select-period max-w-[230px] bg-pagebg"
                v-model="navbarDateFilterStore.selected_date_filter"
                placeholder="Select period"
                :options="dateFilterOptions"
            >
              <template #option="props"><span class="text-[12px] leading-3">{{ props.option.label }}</span></template>
            </Multiselect>
          </div>
          <template
              v-if="authStore.accountPermissions.allowedAny([
                     KPN.DOMESTICROAD_DOMESTICTRANSPORT_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.INTERNATIONALROAD_INTERNATIONALROAD_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.OCEAN_OCEANTRANSPORT_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.AIR_AIR_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.AIR_AIR_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.WAREHOUSINGSIMPLIFY_WAREHOUSINGSIMPLIFYRECEPTIONRETURN_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.WAREHOUSINGSIMPLIFY_WAREHOUSINGSIMPLIFYORDER_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.WAREHOUSING_WAREHOUSINGRECEPTIONRETURN_PAGEACTION_MYGRAPHS_ENABLED,
                     KPN.WAREHOUSING_WAREHOUSINGORDERS_PAGEACTION_MYGRAPHS_ENABLED,
                    ])">
            <ChartLink/>
          </template>
        </template>
        <template v-if="shouldShowLastUpdateFilter">
          <p class="text-text text-xs hidden lg:flex" v-if="getLastSynced(apiNameComputed)">
            Last sync: {{ getLastSynced(apiNameComputed) }} minutes ago
          </p>
        </template>
        <template v-else-if="shouldShowCustomerLedgerEntriesLastUpdateFilter">
          <p class="text-text text-xs hidden lg:flex" v-if="getCustomerLedgerEntriesLastSynced ">
            Last sync: {{ getCustomerLedgerEntriesLastSynced }} minutes ago
          </p>
        </template>
        <template v-else-if="shouldShowVBSInboundsLastUpdateFilter">
          <p class="text-text text-xs hidden lg:flex" v-if="getVBSInboundLastSynced">
            Last sync: {{ getVBSInboundLastSynced }} ago
          </p>
        </template>
        <template v-else-if="shouldShowVBSOutboundsLastUpdateFilter">
          <p class="text-text text-xs hidden lg:flex" v-if="getVBSOutboundLastSynced">
            Last sync: {{ getVBSOutboundLastSynced }} ago
          </p>
        </template>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import {onMounted, ref, computed, watch, onBeforeUnmount, onUnmounted} from "vue";
import {useRoute} from 'vue-router';
import {ApiImportResults, type ApiImportResultsData} from "@/types/site_configuration/api-import-results";
import Multiselect from '@vueform/multiselect';
import {useNavbarDateFilterStore} from "@/stores/navbarDateFilter";
import {useApiStore} from "@/stores/api";
import {KPN} from "@/types/KPN";
import {useAuthStore} from "@/stores/auth";
import NavbarNotifications from "@/components/widgets/notifications/NavbarNotifications.vue";
import ChartLink from "@/components/widgets/chart_buttons/ChartLink.vue";
import NavbarCalendar from "@/components/widgets/NavbarCalendar.vue";
import {useEmpathicWidgetStore, WidgetType} from "@/stores/empathicWidget";

const clickedmenu = ref(false);
const authStore = useAuthStore();
const route = useRoute();
const navbarDateFilterStore = useNavbarDateFilterStore();
const api = useApiStore();
const apiImportData = ref<ApiImportResults[]>([]);
const ONECLICK_ENV = ref(import.meta.env.VITE_ONECLICK_ENV);
const timeoutId = ref<number | null>(null)
const empathicWidgetStore = useEmpathicWidgetStore();

const dateFilterOptions = computed(() => {
  const current_date = new Date();
  const current_year = current_date.getFullYear();
  const current_month = current_date.getMonth();

  const month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  const date_options = [];

  date_options.push({value: 'today', label: 'Today'});

  for (let i = current_month; i >= 0; i--) {
    date_options.push({value: i + 1, label: month_names[i] + ' ' + current_year});
  }

  date_options.push({value: 'this_year', label: 'This Year'});
  date_options.push({value: 'last_year', label: 'Last Year'});
  date_options.push({value: 'last_12m', label: 'Last 12 m'});

  return date_options;
})

const apiNameComputed = computed(() => {
  switch (route.name) {
    case 'domestic-shipments':
      return 'ROAD';
    case 'international-shipments':
      return 'ROAD';
    case 'ocean':
      return 'SEA';
    case 'air':
      return 'SEA';
    case 'inbounds':
      return 'WMS';
    case 'outbounds':
      return 'WMS';
    case 'strongo-shipments':
      return 'STRONGO';
    default:
      return '';
  }
})

const getLastSynced = computed(() => (apiName: string) => {
  const lastApiImport = ref<ApiImportResults>();
  const importData = ref<ApiImportResults[]>([]);
  importData.value = apiImportData.value.filter(el => el.api_name === apiName);
  lastApiImport.value = importData.value.slice(-1)[0];
  const currentDate = new Date();
  if (lastApiImport.value?.start_time === null) {
    return;
  }
  const diff = lastApiImport.value?.start_time.getTime() - currentDate.getTime();
  const lastSynced = Math.floor(diff / (1000 * 60));
  return Math.abs(lastSynced);
})

const getCustomerLedgerEntriesLastSynced = computed(() => {
  const lastApiImport = ref<ApiImportResults>();
  const customerLedgerEntryImportData = ref<ApiImportResults[]>([]);
  customerLedgerEntryImportData.value = apiImportData.value.filter(el => el.api_name == 'Customer Ledger Entry');
  lastApiImport.value = customerLedgerEntryImportData.value.slice(-1)[0];
  const currentDate = new Date();
  if (lastApiImport.value?.start_time === null) {
    return;
  }
  const diff = lastApiImport.value?.start_time.getTime() - currentDate.getTime();
  const lastSynced = Math.floor(diff / (1000 * 60));
  return Math.abs(lastSynced);
})

const getVBSInboundLastSynced = computed(() => {
  const lastVBSInboundApiImport = ref<ApiImportResults>();
  lastVBSInboundApiImport.value = apiImportData.value.find(el => el.api_name == 'Ftp VBS Inbound');

  const currentDate = new Date();
  if (!lastVBSInboundApiImport.value?.start_time) {
    return;
  }
  const diff = currentDate.getTime() - lastVBSInboundApiImport.value?.start_time.getTime();
  const lastVBSInboundSynced = ref('');
  const lastSyncedMinutes = Math.floor(diff / (1000 * 60));
  if (lastSyncedMinutes > 59) {
    const lastSyncedHours = Math.floor(diff / (1000 * 60 * 60));
    lastVBSInboundSynced.value = lastSyncedHours.toString() + ' hours';
  } else {
    lastVBSInboundSynced.value = lastSyncedMinutes.toString() + ' minutes';
  }
  return lastVBSInboundSynced.value;
})

const getVBSOutboundLastSynced = computed(() => {
  const lastVBSOutboundApiImport = ref<ApiImportResults>();
  lastVBSOutboundApiImport.value = apiImportData.value.find(el => el.api_name == 'Ftp VBS Outbound');

  const currentDate = new Date();
  if (!lastVBSOutboundApiImport.value?.start_time) {
    return;
  }
  const diff = currentDate.getTime() - lastVBSOutboundApiImport.value?.start_time.getTime();
  const lastVBSSynced = ref('');
  const lastSyncedMinutes = Math.floor(diff / (1000 * 60));
  if (lastSyncedMinutes > 59) {
    const lastSyncedHours = Math.floor(diff / (1000 * 60 * 60));
    lastVBSSynced.value = lastSyncedHours.toString() + ' hours';
  } else {
    lastVBSSynced.value = lastSyncedMinutes.toString() + ' minutes';
  }
  return lastVBSSynced.value;
})

const selectedDateFilter = computed(() => {
  return navbarDateFilterStore.selected_date_filter;
})
const shouldShowDateFilter = computed(() => {
  return ["home"].includes(route.name);
})
const shouldShowCustomerLedgerEntriesLastUpdateFilter = computed(() => {
  return ["customers"].includes(route.name);
})
const shouldShowVBSInboundsLastUpdateFilter = computed(() => {
  return ["vbs-inbounds"].includes(route.name);
})
const shouldShowVBSOutboundsLastUpdateFilter = computed(() => {
  return ["vbs-outbounds"].includes(route.name);
})
const shouldShowLastUpdateFilter = computed(() => {
  return ["ocean", "air", "domestic-shipments", "international-shipments", "inbounds", "outbounds", "strongo-shipments"].includes(route.name);
})

watch(selectedDateFilter, (new_value: string | number) => {
  const current_date = new Date();
  const end_of_year = new Date(current_date.getFullYear(), 12, 0);
  const end_of_last_year = new Date(current_date.getFullYear() - 1, 12, 0);
  const end_of_last_month = new Date(current_date.getFullYear(), current_date.getMonth(), 0);

  if (typeof new_value === "number" && new_value > 0 && new_value <= 12) {
    const end_of_month = new Date(current_date.getFullYear(), new_value, 0);

    navbarDateFilterStore.from = new Date(
        current_date.getFullYear(),
        new_value - 1,
        1
    )
    navbarDateFilterStore.to = new Date(
        current_date.getFullYear(),
        new_value - 1,
        end_of_month.getDate()
    )
    navbarDateFilterStore.to.setHours(23, 59, 59, 999)
  }

  switch (new_value) {
    case 'today':
      navbarDateFilterStore.from = new Date(
          current_date.getFullYear(),
          current_date.getMonth(),
          current_date.getDate(),
      )
      navbarDateFilterStore.to = new Date(
          current_date.getFullYear(),
          current_date.getMonth(),
          current_date.getDate(),
      )
      navbarDateFilterStore.to.setHours(23, 59, 59, 999)
      break;
    case 'this_year':
      navbarDateFilterStore.from = new Date(
          current_date.getFullYear(),
          0,
          1,
      )
      navbarDateFilterStore.to = new Date(
          end_of_year.getFullYear(),
          end_of_year.getMonth(),
          end_of_year.getDate(),
      )
      navbarDateFilterStore.to.setHours(23, 59, 59, 999)
      break;
    case 'last_year':
      navbarDateFilterStore.from = new Date(
          current_date.getFullYear() - 1,
          0,
          1,
      )
      navbarDateFilterStore.to = new Date(
          end_of_last_year.getFullYear(),
          end_of_last_year.getMonth(),
          end_of_last_year.getDate(),
      )
      navbarDateFilterStore.to.setHours(23, 59, 59, 999)
      break;
    case 'last_12m':
      navbarDateFilterStore.from = new Date(
          current_date.getFullYear(),
          current_date.getMonth() - 12,
          current_date.getDate(),
      )
      navbarDateFilterStore.to = new Date(
          current_date.getFullYear(),
          current_date.getMonth(),
          current_date.getDate() - 1,
      )
      navbarDateFilterStore.to.setHours(23, 59, 59, 999)
      break;
  }
});

const loadLastSyncedData = computed(() => {
  return shouldShowLastUpdateFilter.value ||
      shouldShowVBSInboundsLastUpdateFilter.value ||
      shouldShowVBSOutboundsLastUpdateFilter.value ||
      shouldShowCustomerLedgerEntriesLastUpdateFilter.value;
})

watch(loadLastSyncedData, (new_value) => {
  if (new_value === true) loadLastSynced();
})

onMounted(() => {
  if (loadLastSyncedData.value === true) {
    loadLastSynced();
  }
})
const loadLastSynced = () => {
  api.getItems<ApiImportResults, ApiImportResultsData>('api-import-results', ApiImportResults)
      .then((response) => {
        apiImportData.value = response
      })
      .finally(() => {
        if (loadLastSyncedData.value === true && timeoutId.value === null) {
          timeoutId.value = setTimeout(loadLastSynced, 60000);
        }
      })
}

onBeforeUnmount(() => {
  if (timeoutId.value !== null) {
    clearTimeout(timeoutId.value);
    timeoutId.value = null;
  }
});
const logout = async () => {
  if (authStore.user?.au) {
    logoutAdmin();
  } else {
    await authStore.logoutUser();
  }
}

const logoutAdmin = () => {
  authStore.logoutUser();
  window.close();
}

onUnmounted(() => {
  empathicWidgetStore.closeWidget();
  empathicWidgetStore.resetWidget();
})

const openWidget = (item: any) => {
  const name = authStore.user.getFullName();
  const email = authStore.user.email;

  const fields = {
    customer_name: {field: 'field_1755683901446', value: name},
    customer_email: {field: 'userEmail', value: email},
  };

  empathicWidgetStore.openWidget(WidgetType.HELP, fields);
};

</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.custom-select-period {
  min-height: 30px !important;
  margin-right: 0 !important;
  font-size: 12px !important;
}

.custom-select-period .multiselect-wrapper {
  background: #F2F3F8 !important;
  margin-right: 0 !important;
  min-height: 30px !important;
}

.custom-select-period .multiselect-dropdown {
  max-height: 400px !important;
}

.marquee-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.marquee-wrapper {
  display: flex;
  white-space: nowrap;
  position: absolute;
  width: 200%; /* Dublăm lățimea pentru a include ambele instanțe ale textului */
}

.marquee {
  display: flex;
  width: 100%;
  animation: marquee 20s linear infinite;
}

.marquee-text {
  display: inline-block;
  white-space: nowrap;
  padding-right: 2rem; /* Spațiu între textul repetat */
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

</style>
